import React from "react";
import "../../styles/global-hero.css";

const Hero = () => {
    return (
        <div className="global-hero">
            <div className="container text-center">
                <h1>University News Letter</h1>
                <p>Home &gt; University News Letter</p>
            </div>
        </div>
    );
};

export default Hero;
